import React from 'react';
import styles from './AddChunkCard.module.css';
import {VideoEditorText} from '../VideoEditorText';
import {ReactComponent as ChangeMediaIcon} from '../../../assets/images/changeMedia.svg';
import editChunkStyles from './EditChunkOptions.module.css';
import ContextMenuProviderStore from '../../../modules/ContextMenuProvider/store/ContextMenuProviderStore';
import {inject} from 'mobx-react';

interface Props {
  onAddFromLibrary: () => void;
  onAddFromStoryblocks: () => void;
  disabled?: boolean;
  contextMenuProviderStore?: ContextMenuProviderStore;
}

const AddChunkCard: React.FC<Props> = inject('contextMenuProviderStore')(
  React.memo(
    ({
      onAddFromLibrary,
      onAddFromStoryblocks,
      disabled = false,
      contextMenuProviderStore,
    }: Props) => {
      const openMenu = (e: React.MouseEvent) => {
        if (disabled) return;
        contextMenuProviderStore?.show(
          <div className={editChunkStyles.options}>
            <div
              className={editChunkStyles.option}
              role="button"
              onClick={() => {
                contextMenuProviderStore?.close();
                onAddFromLibrary();
              }}>
              <ChangeMediaIcon
                className={editChunkStyles.editVideoOptionIcon}
              />
              {VideoEditorText.addMediaFromLibrary}
            </div>
            <div
              className={editChunkStyles.option}
              role="button"
              onClick={() => {
                contextMenuProviderStore?.close();
                onAddFromStoryblocks();
              }}>
              <ChangeMediaIcon
                className={editChunkStyles.editVideoOptionIcon}
              />
              {VideoEditorText.addMediaFromStoryblocks}
            </div>
          </div>,
          {x: e.clientX, y: e.clientY},
        );
      };

      return (
        <button
          type="button"
          className={`${styles.addChunkCard} ${
            disabled ? styles.disabled : ''
          }`}
          onClick={openMenu}
          aria-disabled={disabled}>
          <span className={styles.plus}>＋</span>
          <span className={styles.label}>{VideoEditorText.addMedia}</span>
        </button>
      );
    },
  ),
);

export default React.memo(AddChunkCard);
